// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"707":"04a3274c","978":"9334b8a5"}[chunkId] + ".chunk.css";
};